import { useCallback } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const useRecaptcha = () => {
  const executeRecaptcha = useCallback(async (action: string = 'login'): Promise<string | null> => {
    if (!RECAPTCHA_SITE_KEY) {
      console.error('reCAPTCHA site key is not configured');
      return null;
    }

    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.onload = () => {
        if (window.grecaptcha && window.grecaptcha.ready) {
          window.grecaptcha.ready(() => {
            window.grecaptcha.execute(RECAPTCHA_SITE_KEY!, { action })
              .then((token: string) => {
                resolve(token);
              })
              .catch((error: any) => {
                console.error('reCAPTCHA execution failed:', error);
                resolve(null);
              });
          });
        } else {
          console.error('reCAPTCHA not loaded properly');
          resolve(null);
        }
      };
      script.onerror = () => {
        console.error('Failed to load reCAPTCHA script');
        resolve(null);
      };

      // Only add script if not already present
      if (!document.querySelector(`script[src*="google.com/recaptcha"]`)) {
        document.head.appendChild(script);
      } else {
        // Script already loaded, execute directly
        if (window.grecaptcha && window.grecaptcha.ready) {
          window.grecaptcha.ready(() => {
            window.grecaptcha.execute(RECAPTCHA_SITE_KEY!, { action })
              .then((token: string) => {
                resolve(token);
              })
              .catch((error: any) => {
                console.error('reCAPTCHA execution failed:', error);
                resolve(null);
              });
          });
        } else {
          resolve(null);
        }
      }
    });
  }, []);

  return { executeRecaptcha };
};

// Extend the Window interface to include grecaptcha
declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}